import { ProviderLevelReportPayments } from './payments'
import { ProviderLevelReportEnrolments } from './enrolments'
import { ProviderLevelReportEntitlements } from './entitlements'
import { ProviderLevelReportIssSummary } from './iss'
import { ProviderLevelReportSubmissions } from './submissions'
import { ProviderLevelReportIssUnclaimed } from './iss_unclaimed'
import { ProviderLevelReportSubmissionsWithErrors } from './submissions_with_errors'
import { ProviderLevelReportEventsManagement } from './events_management'

export const reportList = [
  {
    name: 'Payments',
    id: 'provider_payments_report',
    component: ProviderLevelReportPayments
  },
  {
    name: 'Enrolments',
    id: 'provider_enrolments_report',
    component: ProviderLevelReportEnrolments
  },
  {
    name: 'Entitlements',
    id: 'provider_entitlements_report',
    component: ProviderLevelReportEntitlements
  },
  {
    name: 'ISS Summary',
    id: 'provider_iss_summary_report',
    component: ProviderLevelReportIssSummary
  },
  {
    name: 'ISS Unclaimed',
    id: 'provider_iss_unclaimed_report',
    component: ProviderLevelReportIssUnclaimed
  },
  {
    name: 'Submissions',
    id: 'provider_submissions_report',
    component: ProviderLevelReportSubmissions
  },
  {
    name: 'Submissions with Errors',
    id: 'provider_submissions_report_with_errors',
    component: ProviderLevelReportSubmissionsWithErrors
  },
  {
    name: 'Events Management',
    id: 'provider_events_management_report',
    component: ProviderLevelReportEventsManagement
  }
]




// WEBPACK FOOTER //
// ./src/provider-level/reports/reports/index.js